


























































import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class Register extends Vue {
  private email: string = "";
  private age: string = "";
  private job: string = "";
  private living_area: string = "";
  private license: string[] = [];
  private hoiku_keiken: string = "";
  private kosodate_keiken: string = "";
  private kibou_style: string = "";
  private kibou_salary: string = "";
  private kibou_bonus: string = "";
  private offer: string = "";

  private age_options = [
    {
      value: "20",
      text: "20～25歳"
    },
    {
      value: "26",
      text: "26～30歳"
    },
    {
      value: "31",
      text: "31～35歳"
    },
    {
      value: "36",
      text: "36～40歳"
    },
    {
      value: "41",
      text: "41歳以上"
    }
  ];
  private job_options = [
    {
      value: "student",
      text: "学生"
    },
    {
      value: "adult1",
      text: "社会人(保育系)"
    },
    {
      value: "adult2",
      text: "社会人(保育以外)"
    },
    {
      value: "adult3",
      text: "休職中"
    }
  ];
  private living_area_options = [
    {
      value: "tokyo1",
      text: "東京(23区内)"
    },
    {
      value: "tokyo2",
      text: "東京(23区外)"
    },
    {
      value: "other",
      text: "その他"
    }
  ];
  private license_options = [
    {
      value: "hoikushi",
      text: "保育士"
    },
    {
      value: "youichien_kyoyu",
      text: "幼稚園教諭"
    },
    {
      value: "jidou_shidouin",
      text: "児童指導員"
    },
    {
      value: "kangoshi",
      text: "看護師"
    },
    {
      value: "eiyoushi",
      text: "栄養士"
    },
    {
      value: "other",
      text: "その他"
    }
  ];
  private hoiku_keiken_options = [
    {
      value: "ari",
      text: "あり"
    },
    {
      value: "nashi",
      text: "なし"
    }
  ];
  private kosodate_keiken_options = [
    {
      value: "ari",
      text: "あり"
    },
    {
      value: "nashi",
      text: "なし"
    }
  ];
  private kibou_style_options = [
    {
      value: "seiki",
      text: "正規職員"
    },
    {
      value: "part1",
      text: "パート・アルバイト(フルタイム)"
    },
    {
      value: "part2",
      text: "パート・アルバイト(短時間)"
    },
    {
      value: "ok",
      text: "どれでも"
    }
  ];
  private kibou_salary_options = [
    {
      value: "8",
      text: "8万以下(扶養内)"
    },
    {
      value: "10",
      text: "10～15万円"
    },
    {
      value: "16",
      text: "16～20万円"
    },
    {
      value: "21",
      text: "21～25万円"
    },
    {
      value: "26",
      text: "26～30万円"
    },
    {
      value: "31",
      text: "31万円以上"
    }
  ];
  private kibou_bonus_options = [
    {
      value: "ari",
      text: "あり"
    },
    {
      value: "nashi",
      text: "なし"
    }
  ];
  private offer_options = [
    {
      value: "direct",
      text: "直接連絡を受ける"
    },
    {
      value: "indirect",
      text: "弊社を通して受ける"
    },
    {
      value: "no",
      text: "受けない"
    }
  ];
}
